import TransportModes from '../../containers/TransportModes';
import transportModeReducer from './TransportModeReducer';

const initialState = {
  Any: {}, First: {}, Last: {}, Each: {},
};

function wrapper(state, action, legCode) {
  return (!action.legCode || action.legCode === legCode)
    ? transportModeReducer(state, action, TransportModes[legCode].nodes.map(node => node.value))
    : state;
}

export default (state = initialState, action) => {
  const Any = wrapper(state.Any, action, 'Any');
  const First = wrapper(state.First, action, 'First');
  const Last = wrapper(state.Last, action, 'Last');
  const Each = wrapper(state.Each, action, 'Each');
  return {
    Any, First, Last, Each,
  };
};

